import { render, staticRenderFns } from "./UserCardDetail.vue?vue&type=template&id=4ae372b9&scoped=true"
import script from "./UserCardDetail.vue?vue&type=script&lang=js"
export * from "./UserCardDetail.vue?vue&type=script&lang=js"
import style0 from "./UserCardDetail.vue?vue&type=style&index=0&id=4ae372b9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae372b9",
  null
  
)

export default component.exports